import React from "react";
import { PageHeader, Card } from "@/components/UIKit";
import { Workflow, CheckCircle2, Clock, ArrowRight } from "lucide-react";

const flows = [
  {
    name: "Ny kunde onboarding",
    status: "aktiv",
    steps: ["Ny kunde opprettes", "Fnr/orgnr valideres (mod 11)", "Målepunkt hentes fra Elhub", "Avtale opprettes", "Leverandørbytte trigges (BRS-NO-101)", "Første faktura planlegges"],
  },
  {
    name: "Månedlig fakturering",
    status: "aktiv",
    steps: ["Måleverdier hentes fra Elhub (BRS-NO-311)", "Spotpris hentes fra Nord Pool", "Prismotor beregner", "PDF/EHF genereres", "Sendes til kunde", "KID og forfall registreres"],
  },
  {
    name: "Purreflyt",
    status: "aktiv",
    steps: ["Sjekk forfalte fakturaer daglig", "Første purring +7 dager", "Andre purring +14 dager", "Inkassovarsel +21 dager", "Eksport til inkassobyrå"],
  },
  {
    name: "Innflytting / utflytting",
    status: "aktiv",
    steps: ["Skjema fra kundeservice", "Elhub-oppslag på adresse", "BRS-melding sendes", "Avtale opprettes/avsluttes", "Sluttfaktura genereres"],
  },
  {
    name: "Automatisk avstemming",
    status: "klar",
    steps: ["Bankfil (OCR) importeres", "KID matches mot faktura", "Innbetaling registreres", "Status oppdateres", "Avvik varsles til økonomi"],
  },
];

export default function Automatisering() {
  return (
    <div data-testid="automatisering-page">
      <PageHeader title="Automatisering" subtitle="Workflow engine — automatiske forretningsprosesser" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {flows.map((f, idx) => (
          <Card key={idx} className="p-5" testid={`flow-${idx}`}>
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2.5">
                <div className="h-8 w-8 rounded-md bg-emerald-500/10 border border-emerald-500/20 grid place-items-center">
                  <Workflow className="h-4 w-4 text-emerald-400" />
                </div>
                <div className="font-heading font-medium text-zinc-100">{f.name}</div>
              </div>
              <span className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full ${
                f.status === "aktiv" ? "text-emerald-400 bg-emerald-500/10 border border-emerald-500/20" : "text-amber-400 bg-amber-500/10 border border-amber-500/20"
              }`}>
                {f.status === "aktiv" ? <><CheckCircle2 className="h-3 w-3" /> Aktiv</> : <><Clock className="h-3 w-3" /> Klar</>}
              </span>
            </div>
            <div className="space-y-2">
              {f.steps.map((s, i) => (
                <div key={i} className="flex items-start gap-2.5 text-sm">
                  <div className="mt-0.5 h-4 w-4 rounded-full bg-zinc-900 border border-zinc-800 grid place-items-center shrink-0 text-[10px] text-zinc-500">{i + 1}</div>
                  <span className="text-zinc-300 leading-snug">{s}</span>
                </div>
              ))}
            </div>
          </Card>
        ))}
      </div>

      <Card className="mt-4 p-5">
        <div className="flex items-start gap-3">
          <div className="h-8 w-8 rounded-md bg-blue-500/10 border border-blue-500/20 grid place-items-center shrink-0">
            <Workflow className="h-4 w-4 text-blue-400" />
          </div>
          <div>
            <div className="font-heading font-medium text-zinc-100 mb-1">Event-drevet arkitektur</div>
            <div className="text-sm text-zinc-400 leading-relaxed">
              Alle prosesser publiserer hendelser til intern event-buss (Celery/RQ i produksjon). Dette gir sømløs
              integrasjon med Elhub, Nord Pool, bank/OCR, regnskap og fremtidige tjenester som elbillading og batteri.
              Full audit-logg dokumenterer hver eneste automatiske handling.
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
